<div class="td-wb-scrollable-container-slider">
  <button
    class="td-wb-scrollable-container-slider__button td-wb-scrollable-container-slider__button--left"
    [disabled]="!showPrevButton()"
    [attr.aria-label]="'tdWb.pagination.PREVIOUS' | tdWbTranslate"
    tdWbIconButton
    type="button"
    (click)="previous()">
    <td-wb-icon size="8x16"
      iconId="arrow-left" />
  </button>
  <!-- Slider Controls -->
  <div tdWbScrollable
       class="td-wb-scrollable-container-slider__container">
    <div *ngTemplateOutlet="content() || null"></div>
  </div>
  <button
    class="td-wb-scrollable-container-slider__button td-wb-scrollable-container-slider__button--right"
    [disabled]="!showNextButton()"
    [attr.aria-label]="'tdWb.pagination.NEXT' | tdWbTranslate"
    tdWbIconButton
    type="button"
    (click)="next()">
    <td-wb-icon size="8x16"
      iconId="arrow-right" />
  </button>
</div>
